import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    dialogHeaderContainer: {
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center"
    },
    iconContent: {
        justifyContent: "center",
        alignItems: "center",
        height: 55,
        width: 55
    },
    contentContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    infoContent: {
        flexDirection: "row",
        alignItems: "center"
    },
    textWrapper: {
        justifyContent: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    infoCardContainer: {
        flexDirection: "row"
    },
    contactRow: {
        flexDirection: "row"
    },
    dialogIconWrapper: {
        alignSelf: "center"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    submitButton: {
        height: 56
    }
});
export default stylesheet;
